import React from 'react'

import style from './DetailedViewCard.module.css'

const DetailedViewCard = ({ className, children }) => {
  return children ? <div className={`${style.card} ${className ?? ''}`}>{children}</div> : null
}

export default DetailedViewCard
